import { render } from "./ModalSuccess.vue?vue&type=template&id=728d3ffa"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"

import "./ModalSuccess.vue?vue&type=style&index=0&id=728d3ffa&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__